import React from 'react';
import {
  NavigationButtonProps,
  NavigationButtons,
  TextInputMolecule,
} from '@molecules/index';
import { ErrorMessages } from '@types';
import { ErrorSummary, Label } from '@atoms/ErrorSummary/ErrorSummary';

interface TextInputProps {
  id?: string;
  initialTextValue?: string;
  labelText: string;
  description?: string;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  maxLength?: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface MultipleTextInputTemplateProps {
  textInputList: TextInputProps[];
  title?: string;
  isLabelTextTitle?: boolean;
  titleClassName?: string;
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
  errorMessages?: ErrorMessages[];
}

export const MultipleTextInputTemplate: React.FC<
  MultipleTextInputTemplateProps
> = ({
  textInputList,
  title,
  isLabelTextTitle,
  titleClassName,
  buttonNext,
  buttonPrevious,
  errorMessages,
}) => {
  return (
    <div className="my-6 flex flex-col gap-6">
      <ErrorSummary messages={errorMessages} />
      {title ? (
        <Label
          className={`${titleClassName} !text-brand-primary body-2 text-h2`}
          htmlFor={title}
          text={title}
          isTitle={isLabelTextTitle}
          id={title}
        />
      ) : null}
      <form className="flex flex-col gap-2">
        {textInputList.map((textInput, index) => (
          <TextInputMolecule
            key={index}
            id={textInput.errorPath ?? textInput.id}
            label={textInput.labelText}
            description={textInput.description}
            errorPath={textInput.errorPath}
            errorMessages={textInput.errorMessages}
            onChange={textInput.onChange}
            maxLength={textInput.maxLength}
            value={textInput.initialTextValue}
          />
        ))}
      </form>
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
